import axios from "axios";
import { Storage } from "@ionic/storage";
import { loadingController, alertController } from "@ionic/vue";
import router from "@/router";

export default {
    config: {
        debug: false,
        // debug: true,

        base_url: '/api',

        token_key: 'api_token',
        android_version: '3.0.14',
        ios_version: '3.0.14',

        voice: [
            { id: 1, path: '/assets/voice/S001.mp3' },
            { id: 2, path: '/assets/voice/S002.mp3' },
            { id: 3, path: '/assets/voice/S003.mp3' },
            { id: 4, path: '/assets/voice/S004.mp3' },
            { id: 5, path: '/assets/voice/S005.mp3' },
            { id: 6, path: '/assets/voice/S006.mp3' },
            { id: 7, path: '/assets/voice/S007.mp3', tips: '/assets/voice/S008.mp3' },
            { id: 8, path: '/assets/voice/S009.mp3' },
            { id: 9, path: '/assets/voice/S010.mp3' },
            { id: 10, path: '/assets/voice/story_option.mp3' },
            { id: 11, path: '/assets/voice/S015.mp3' },
            { id: 12, path: '/assets/voice/S016_a.mp3' },
            { id: 13, path: '/assets/voice/S016_b_v2.mp3', tips: '/assets/voice/S014.mp3' },
            { id: 14, path: '/assets/voice/S017.mp3' },
            { id: 15, path: '/assets/voice/S018.mp3' },
            { id: 16, path: '/assets/voice/S019.mp3' },
            { id: 17, path: '/assets/voice/S020.mp3' },
            { id: 18, path: '/assets/voice/S021a.mp3' },
            { id: 19, path: '/assets/voice/S021b.mp3' },


            { id: 101, path: '/assets/voice/S_word_apple.mp3' },
            { id: 102, path: '/assets/voice/S_word_pear.mp3' },
            { id: 103, path: '/assets/voice/S_word_lemon.mp3' },
            { id: 104, path: '/assets/voice/S_word_banana.mp3' },
            { id: 105, path: '/assets/voice/S_word_watermelon.mp3' },
            { id: 106, path: '/assets/voice/S_word_durian.mp3' },
            { id: 107, path: '/assets/voice/S_word_pencil.mp3' },
            { id: 108, path: '/assets/voice/S_word_ruler.mp3' },
            { id: 109, path: '/assets/voice/S_word_chalk.mp3' },
            { id: 110, path: '/assets/voice/S_word_scissors.mp3' },
            { id: 111, path: '/assets/voice/S_word_glue.mp3' },
            { id: 112, path: '/assets/voice/S_word_pair_of_compasses.mp3' },
            { id: 113, path: '/assets/voice/S_word_tie.mp3' },
            { id: 114, path: '/assets/voice/S_word_shirt.mp3' },
            { id: 115, path: '/assets/voice/S_word_trousers.mp3' },
            { id: 116, path: '/assets/voice/S_word_socks.mp3' },
            { id: 117, path: '/assets/voice/S_word_gloves.mp3' },
            { id: 118, path: '/assets/voice/S_word_coat.mp3' },
            { id: 119, path: '/assets/voice/S_word_house.mp3' },
            { id: 120, path: '/assets/voice/S_word_mall.mp3' },
            { id: 121, path: '/assets/voice/S_word_school.mp3' },
            { id: 122, path: '/assets/voice/S_word_hospital.mp3' },
            { id: 123, path: '/assets/voice/S_word_villa.mp3' },
            { id: 124, path: '/assets/voice/S_word_apartment.mp3' },
            { id: 125, path: '/assets/voice/S_word_bus.mp3' },
            { id: 126, path: '/assets/voice/S_word_taxi.mp3' },
            { id: 127, path: '/assets/voice/S_word_mtr.mp3' },
            { id: 128, path: '/assets/voice/S_word_tram.mp3' },
            { id: 129, path: '/assets/voice/S_word_bicycle.mp3' },
            { id: 130, path: '/assets/voice/S_word_airplane.mp3' },
        ],

        confirmModal: {
            isOpen: false,
            title: 'title',
            content: 'content',
            confirmFun: function () {
                return;
            },
            didDismissFun: function () {
                return;
            }
        },

        alertModal: {
            isOpen: false,
            title: 'title',
            content: ['content'],
            didDismissFun: function () {
                return;
            }
        }
    },

    apiGetData(url: string, has_token = false, loading?: any) {
        if (!navigator.onLine) {
            this.showAlert('無法連接到伺服器，請檢查您的網絡或稍後再試一次', '網絡連線錯誤');
            this.hideLoading(loading);
            return new Promise(() => {
                return false;
            });
        }

        url = this.config.base_url + url;

        if (has_token) {
            return this.getToken().then(token => {
                if (url.indexOf('?') === -1) {
                    url = url + '?api_token=' + token;
                } else {
                    url = url + '&api_token=' + token;
                }

                return this.apiHandleGetData(url, loading);
            })
        } else {
            return this.apiHandleGetData(url, loading);
        }
    },

    apiPostData(url: string, data: any, has_token = false, loading?: any) {
        if (!navigator.onLine) {
            this.showAlert('無法連接到伺服器，請檢查您的網絡或稍後再試一次', '網絡連線錯誤');
            this.hideLoading(loading);
            return new Promise(() => {
                return false;
            });
        }

        url = this.config.base_url + url;
        if (has_token) {
            return this.getToken().then(token => {
                if (url.indexOf('?') === -1) {
                    url = url + '?api_token=' + token;
                } else {
                    url = url + '&api_token=' + token;
                }
                return this.apiHandlePostData(url, data, loading);
            })
        } else {
            return this.apiHandlePostData(url, data, loading);
        }
    },

    apiHandleGetData(url: string, loading?: any) {
        return axios.get(url).then(response => {
            return this.apiHandleResponse(response, loading);
        }).catch(err => {
            this.showAlert('無法連接到伺服器，請檢查您的網絡或稍後再試一次', '網絡連線錯誤');
            this.hideLoading(loading);
            return false;
        })
    },

    apiHandlePostData(url: string, data: any, loading?: any) {
        return axios.post(url, data).then(response => {
            return this.apiHandleResponse(response, loading);
        }).catch(err => {
            this.showAlert('無法連接到伺服器，請檢查您的網絡或稍後再試一次', '網絡連線錯誤');
            this.hideLoading(loading);
            return false;
        })

    },

    apiHandleResponse(response: any, loading?: any) {
        this.hideLoading(loading);

        if (response.data.code == -999) {
            this.clearSession();
            this.showAlert(response.data.msg, '錯誤', function () {
                router.push('/login');
            })
            return false;
        }

        if (response.data.status !== 0) {
            this.showAlert(response.data.message.description, response.data.message.title);
        }
        if (response.data.status < 0) {
            return false;
        }

        return response.data.data;
    },

    initStorage() {
        const storage = new Storage();
        storage.create();

        return storage;
    },

    clearStorage() {
        const storage = this.initStorage();
        return storage.clear();
    },

    getStorage(key: string) {
        const storage = this.initStorage();
        return storage.get(key)
    },

    setStorage(key: string, value: any) {
        const storage = this.initStorage();
        return storage.set(key, value)
    },

    removeStorage(key: string) {
        const storage = this.initStorage();
        return storage.remove(key)
    },

    clearSession() {
        const storage = this.initStorage();
        const SESSION_KEYS = [
            this.config.token_key,
            'users',
            'staff',
            'user_info',
            'account_mobile',
            'test_data',
            'storage_test_id',
            'is_literate', // 兼容舊版未命名空間化的殘留
        ];
        const SESSION_PREFIXES = ['result_', 'followUp_', 'is_literate_'];
        return storage.keys().then((keys: string[]) => {
            const toRemove = keys.filter(k =>
                SESSION_KEYS.indexOf(k) !== -1 || SESSION_PREFIXES.some(p => k.indexOf(p) === 0)
            );
            return Promise.all(toRemove.map(k => storage.remove(k)));
        });
    },

    clearFlow() {
        const storage = this.initStorage();
        return this.getUserInfo().then((user_info: any) => {
            const keys: string[] = ['test_data', 'storage_test_id', 'user_info'];
            if (user_info && user_info.id) {
                keys.push('result_' + user_info.id);
                keys.push('followUp_' + user_info.id);
                keys.push('is_literate_' + user_info.id);
            }
            return Promise.all(keys.map(k => storage.remove(k)));
        });
    },

    getToken() {
        return this.getStorage(this.config.token_key);
    },

    removeToken() {
        return this.removeStorage(this.config.token_key);
    },

    showConfirmModal(element: object, title: string, content: string, confirmFun: Function) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        element.common.config.confirmModal.isOpen = true;
        this.config.confirmModal.title = title;
        this.config.confirmModal.content = content;

        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.config.confirmModal.confirmFun = confirmFun;

        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        element.common.config.confirmModal.didDismissFun = function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            element.common.config.confirmModal.isOpen = false;
        }
    },

    showAlertModal(element: object, title: string, content: any) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        element.common.config.alertModal.isOpen = true;
        this.config.alertModal.title = title;
        this.config.alertModal.content = content;

        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        element.common.config.alertModal.didDismissFun = function () {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            element.common.config.alertModal.isOpen = false;
        }
    },

    showLoading() {
        const loading = loadingController.create({
            cssClass: 'loading',
            message: '加載中',
        });
        loading.then(response => {
            response.present();
        })
        return loading;
    },

    hideLoading(loading: Promise<any>) {
        if (typeof loading == 'object') {
            loading.then((response) => {
                response.dismiss();
            })
        }
    },

    showAlert(content: string, title = '錯誤', fun?: any, text?: string) {
        const alert = alertController.create({
            cssClass: 'alert',
            header: title,
            message: content,
            mode: 'ios',
            backdropDismiss: false,
            buttons: [
                {
                    text: text ? text : '確定',
                    handler: () => {
                        if (fun !== undefined) {
                            fun();
                        }
                    }
                }
            ]
        }).then(response => {
            response.present();
            return response;
        });

        return alert;
    },

    showConfirm(content: string, title: string, fun: any, param?: object, text?: string, showCancel = true) {
        const buttons: any[] = [
            {
                text: text ? text : '確定',
                handler: () => {
                    fun(param)
                }
            },
        ];
        if (showCancel) {
            buttons.push({
                text: '取消',
                // handler: () => {
                //
                // }
            });
        }

        alertController.create({
            cssClass: 'alert',
            header: title,
            message: content,
            mode: 'ios',
            backdropDismiss: false,
            buttons: buttons
        }).then(response => {
            response.present();
        });
    },

    splitMobile(mobile: string) {
        return mobile.slice(0, 4) + ' ' + mobile.slice(4);
    },

    splitMobileEncrypt(mobile: string) {
        return mobile.slice(0, 2) + '** **' + mobile.slice(6);
    },

    getVoice(id: number) {
        const res = this.config.voice.find(function (item) {
            return item.id == id;
        })

        if (res) {
            return res.path;
        } else {
            return false;
        }
    },
    initData(element: any) {
        Object.assign(element.$data, element.$options.data());
    },
    getUserInfo() {
        return this.getStorage('user_info');
    },
    getTestRecordTime(initial_time: number) {
        return (new Date().getTime() - initial_time) / 1000;
    },
}
